import { ComponentType } from "react";
import { useAuth } from "./auth/useAuth";
import { Redirect } from "react-router-dom";

// const AuthRequired = () => <Redirect to={{ pathname: "/form/login" }} />;
const AuthRequired = () => null;

type ProtectedRouteProps = {
  component: ComponentType;
};
export const ProtectedRoute = ({ component }: ProtectedRouteProps) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return null;
  }

  const Component = isAuthenticated ? component : AuthRequired;
  return <Component />;
};
